export const SIGN_OUT_OK = 'SIGN_OUT_OK';
export const SIGN_OUT_CANCEL = 'SIGN_OUT_CANCEL';
